export const GET_ORGANIZATION_AGENTS_START =
  'GET_ORGANIZATION_AGENTS_START';
export const GET_ORGANIZATION_AGENTS_SUCCESS =
  'GET_ORGANIZATION_AGENTS_SUCCESS';
export const GET_ORGANIZATION_AGENTS_ERROR =
  'GET_ORGANIZATION_AGENTS_ERROR';
